import { render, staticRenderFns } from "./veHqWupinShow.vue?vue&type=template&id=00b8ff59&scoped=true"
import script from "./veHqWupinShow.vue?vue&type=script&lang=js"
export * from "./veHqWupinShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b8ff59",
  null
  
)

export default component.exports